/**
 * @file enum-actions.ts
 * @description Redux Toolkit асинхронные действия для управления перечислениями (enums) в Task Manager приложении. Предоставляет функцию getItems для загрузки элементов перечислений с сервера через API, включая обработку ошибок и типизацию ответов. Используется для получения справочных данных различных типов (статусы, категории, приоритеты и т.д.) с централизованной обработкой состояний загрузки.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@api/config', '@reduxjs/toolkit', 'axios']
 * @related-files ['src/features/enums/enum-slice.ts', 'src/api/config.ts', 'src/types/mes-object.ts']
 */

import instance from '@api/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export const getItems = createAsyncThunk('auth/getItems', async ({ type }: { type: string }, { rejectWithValue }) => {
    try {
        const response: AxiosResponse = await instance().post(`list/${type}`);

        return { type, items: response.data };
    } catch (error: any) {
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
